import moment from 'moment'; // this is marked as an external dependency, so it won't be bundled by webpack

export interface TimeSpanValue {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

/**
 * @param value ISO 8601 String value
 */
export function getValue(value: string): TimeSpanValue {
  const duration = getMoment().duration(value);

  return {
    // we cannot use duration.days() here because it will return at maximum "31" and after that will increase month value
    // e.g. moment.duration("P31DT").days() // 0
    // e.g. moment.duration("P32DT").days() // 1
    days: Math.floor(duration.asDays()),
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };
}

export function getIsoString(time: TimeSpanValue) {
  const { days, hours, minutes, seconds } = time;
  return getMoment()
    .duration(`${days}.${hours}:${minutes}:${seconds}`)
    .toISOString();
}

export function timeIsEmpty(state: TimeSpanValue) {
  return state.days === 0 && state.hours === 0 && state.minutes === 0 && state.seconds === 0;
}

export function getTimeSpanDisplayValue(time: TimeSpanValue) {
  return `${time.days}:${time.hours}:${time.minutes}:${time.seconds}`;
}

function getMoment() {
  // use window.moment, to work around something funny with this setup and webpack externals,
  // which I don't have time to sort out, right now.
  return (window as any).moment as typeof moment;
}
